import {
	Apartment,
	Domain,
	EmojiTransportation,
	Home,
	Store
} from '@mui/icons-material';

export const OBJECTS_TYPES = {
	APARTMENTS: 'apartments',
	OFFICES: 'offices',
	BUILDINGS: 'buildings',
	COMPLEXES: 'complexes',
	COMMERCES: 'commerces',
	PROPERTIES: 'properties'
};


export const ICONS_BY_OBJECT = {
	[OBJECTS_TYPES.APARTMENTS]: Home,
	[OBJECTS_TYPES.OFFICES]: EmojiTransportation,
	[OBJECTS_TYPES.BUILDINGS]: Apartment,
	[OBJECTS_TYPES.COMMERCES]: Store,
	[OBJECTS_TYPES.COMPLEXES]: Domain
};

export const SALE_RENT_TYPE = {
	SALE: 'sale',
	RENT: 'rent'
};

export const INPUT_SOURCE = {
	NUMBER_OF_FLOORS: 'number_of_floors',
	COMPANY_ID: 'company_id',
	BUILDING_ID: 'building_id',
	COMPLEX_ID: 'complex_id',
	LOCATION_DATA: 'location_data',
	ADDRESS: 'address',
	NAME: 'name',
	AREA: 'area',
	FLOOR: 'floor',
	APARTMENT_NUMBER: 'apartment_number',
	NUMBER_OF_ROOMS: 'number_of_rooms',
	STATE: 'state',
	OBJECT_ACTIONS: 'actions',
	RENT_UAH_PRICE_BY_METER: `rent_uah_price_by_meter`,
	RENT_UAH_OBJECT_PRICE: `rent_uah_object_price`,
	RENT_USD_PRICE_BY_METER: `rent_usd_price_by_meter`,
	RENT_USD_OBJECT_PRICE: `rent_usd_object_price`,
	SALE_UAH_PRICE_BY_METER: `sale_uah_price_by_meter`,
	SALE_UAH_OBJECT_PRICE: `sale_uah_object_price`,
	SALE_USD_PRICE_BY_METER: `sale_usd_price_by_meter`,
	SALE_USD_OBJECT_PRICE: `sale_usd_object_price`,
	IMAGES: 'image',
	VIDEOS: 'videos',
	LAYOUT: 'layout',
	DOCUMENTS: 'document',
	TAGS: 'tags',
	COMMENTS: 'comments',
	SALES_ID: 'sales_id',
	FURNISHING: 'furnishing',
	CONTACTS_JSONB: 'contacts_jsonb',
	CONTACT_ID: 'contact_id',
	FACADE: 'facade',
	TERRACE: 'terrace',
	OFFICE_USABLE_AREA: 'office_usable_area',
	OFFICE_COEFFICIENT: 'office_coefficient',
	OFFICE_RENT_AREA: 'office_rent_area',
	TERRACE_USABLE_AREA: 'terrace_usable_area',
	TERRACE_COEFFICIENT: 'terrace_coefficient',
	TERRACE_RENT_AREA: 'terrace_rent_area',
	CONFIGURATION: 'configuration',
	LUN_LINK: 'lun_link',
	SITE_LINK: 'site_link',
	INSTAGRAM_LINK: 'instagram_link',
	MANAGEMENT_FORM: 'management_form',
	FUNCTION_TYPE: 'function_type',
	BLOCK_SECTION: 'block_section',
	IN_OPERATION: 'in_operation',
	DEVELOPER: 'developer',
	SET_STATUS_DATE: 'set_status_date',
	STATUS: 'status',
} as const;

export const OBJECT_STATUSES_ID_MAP = {
	AVAILABLE: 1,
	RENTED: 2,
	SOLD: 3
};
